// import { useLang } from '../../context/LangContext';
// import type { CarStore } from '../../hooks/useCarStore';
// import { Icon } from '../../icons/Icons';
// import { faPlate } from '../../utils/format';
import { faPlate } from '@/functions/formats';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';

export default function LookupResult() {
  const { searchedPlate } = useLayoutContext();
  const plateLabel = faPlate(searchedPlate?.plate);
  const t = useTranslations('HomePage.hero.lookipResult');

  const result = {
    title: t('title'),
    // plateLabel: '۱۲ الف ۳۴۵ — ایران ۶۷',
    live: t('tag'),
    aiTag: t('notif.title'),
    aiNote: t('notif.text'),
    items: [
      {
        icon: <MainIcons.flashIcon fill="var(--brand-deep)" />,
        label: t('card1.title'),
        value: t('card1.text'),
        tag: t('card1.value'),
        color: 'var(--danger)',
        tagBg: '#FDECE7',
        tagColor: 'var(--danger)',
      },
      {
        icon: <MainIcons.coinIcon fill="var(--brand-deep)" />,
        label: t('card2.title'),
        value: t('card2.text'),
        tag: t('card2.value'),
        color: 'var(--green)',
        tagBg: 'var(--green-bg)',
        tagColor: 'var(--green)',
      },
      {
        icon: <MainIcons.shieldIcon fill="var(--brand-deep)" />,
        label: t('card3.title'),
        value: t('card3.text'),
        tag: t('card3.value'),
        color: 'var(--accent-deep)',
        tagBg: 'var(--accent-bg)',
        tagColor: 'var(--accent-deep)',
      },
      {
        icon: <MainIcons.clockIcon fill="var(--brand-deep)" />,
        label: t('card4.title'),
        value: t('card4.text'),
        tag: t('card4.value'),
        color: 'var(--brand-deep)',
        tagBg: 'var(--tag-bg)',
        tagColor: 'var(--brand-deep)',
      },
    ],
  };

  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <div className={styles.headLeft}>
          <div className={styles.headMark}>
            {/* <Icon id="#ic-spark" size={17} style={{ color: '#fff' }} /> */}
            <MainIcons.notifIcon fill="var(--paper)" />
          </div>
          <div>
            <div className={styles.title}>{result?.title}</div>
            <div className={styles.plate}>{plateLabel}</div>
          </div>
        </div>
        <span className={styles.live}>{result?.live}</span>
      </div>

      <div className={styles.grid}>
        {result?.items.map((r) => (
          <div key={r?.label} className={styles.item}>
            <div className={styles.itemHead}>
              {r?.icon}
              <span className={styles.tag} style={{ background: r?.tagBg, color: r?.tagColor }}>
                {r?.tag}
              </span>
            </div>
            <div className={styles.itemLabel}>{r?.label}</div>
            <div className={styles.itemValue} style={{ color: r?.color }}>
              {r?.value}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.ai}>
        <MainIcons.notifIcon fill="var(--accent)" width="18px" height="18px" />
        <div>
          <div className={styles.aiTag}>{result?.aiTag}</div>
          <div className={styles.aiNote}>{result?.aiNote}</div>
        </div>
      </div>
    </div>
  );
}
